import { EpimsBaseEntityDto } from './epim-base.dto';
export class PipelineExpirationNotificationSettingsDto extends EpimsBaseEntityDto   {
   
 StaffId: string;
 StaffName: string;

 StaffEmail: string;
 NotificationStartsAtYears: number;
 NumberOfNotification: number;
 FrequencyOfNotification: number;
 IntervalNoDays: number;
 Recipients: string;
 NotificationContent: string;

    CurrentDay: number;
    CurrentDayName: string;
    CurrentMonth: number;
    CurrentMonthName: string;
    CurrentQuarter: number;
    CurrentQuarterName: string;
    FrequencyType: string;
}